<template>
    <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
            <v-btn color ="blue-grey" v-on="on" text>가입하기</v-btn>
        </template>
        <v-card>
            <v-img
                class="white--text"
                height="310px"
                src="/join.jpg"
            >
                <v-card-title class="align-end fill-height font-italic">Welcome!</v-card-title>
            </v-img>
            <v-card-text>
                <p class="text-center my-5 pt-5"><span class="title indigo--text pr-3">"{{ group.name }}"</span>에 참여하시겠습니까?</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading='loading' depressed dark class="my-5" color="blue-grey" @click="joinUs">Yes!</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '@/fb'

export default {
    name: 'JoinUs',
    props: [ 'user', 'group', 'groupId' ],
    data: () => ({
        dialog: false,
        loading: false,
        members: null,
        joinedGroups: []
    }),
    methods: {
        joinUs(){
            this.loading = true;

            // add the new member to the group
            this.members = this.group.members;
            this.members.unshift({
                alias: this.user.alias,
                name: this.user.name,
                timeStamp: Date.now()
            });

            // add the new group to the user info
            // this.joinedGroups = this.user.joinedGroups
            this.joinedGroups.push({
                id: this.groupId,
                history: [this.user.total],
            })

            // update the members of the group
            db.collection('groups').doc(this.groupId).update({
                members: this.members
            }).then(() => {
                 db.collection('users').doc(this.user.id).update({
                    joinedGroups: this.joinedGroups
                }).then(() => {
                    this.dialog = false;
                    this.loading = false;
                    this.$router.push({ name: 'Games', params: { group_id: this.groupId} });
                });
            })
        }
    },
    created(){
        if(this.user.joinedGroups == null){
            this.joinedGroups = []
        } else {
            this.joinedGroups = this.user.joinedGroups
        }
    }
}
</script>

<style>

</style>